import SVGProps from 'src/components/icons/config/svg-props' //
// Auto-generated file created by svgr-cli source svg-template.cjs
// Run npm run generate-icons to update
// Do not edit
const SvgClockIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill="none"
    viewBox="0 0 64 64"
    role="img"
    className="icon"
    {...props}
  >
    <g fill="currentColor" fillRule="evenodd" clipRule="evenodd">
      <path d="M32 6.232a25.768 25.768 0 1 0 0 51.536 25.768 25.768 0 0 0 0-51.536M3.2 32a28.8 28.8 0 1 1 57.6 0 28.8 28.8 0 0 1-57.6 0" />
      <path d="M32 32.938V16h3.2v16.938a3.2 3.2 0 0 1-.938 2.262l-9.13 9.133-2.265-2.266z" />
    </g>
  </svg>
)
export default SvgClockIcon
